import { ZoneModel } from 'models/zone.model';

export const ALL_ZONES = 'ALL_ZONES';

interface setAllZones {
  type: typeof ALL_ZONES;
  payload: { zones: ZoneModel[]; allZones: string[] };
}

export type ZonesActions = setAllZones;
